<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <h5
      class="ui header"
      style="text-align: center;text-decoration:underline"
    >
      Choose Reservation
    </h5>

    <div v-if="reservations && reservations.length">
      <div 
        class="ui items"
        v-for="reservation in reservations"
        :key="reservation.id"
      >
        <div class="item" style="cursor: pointer;" @click="setReservation(reservation)">
          <div class="content"> 
            Reservation
            <div class="meta">
              <div v-html="getPackages(reservation)" />
            </div>
            <div class="extra">
              
            </div>
          </div>
        </div>
        <div class="ui divider" />
      </div>
    </div>
    <div 
      class="centered-header" 
      style="cursor: pointer; padding-bottom: 5px" 
      @click="
        navigateTo('New_Reservation', {
          key: 'query',
          value: patient
        })
      "
    >
      <a class="item"> Create new reservation </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    patient: {
      type: Object,
      required: true 
    },
  },
  data() {
    return {
      loading: true,
      reservations: [],
      transactions: []
    }
  },
  mounted () {
    this.$http.get(`patients/${this.patient.id}/reservations/opened`).then(response => {
      this.transactions = response.data.meta.transactions
      this.reservations = response.data.reservations
      this.loading = false
    });
  },
  methods: {
    // getPackages(reservation) {
    //   let packagesString = ''
    //   reservation.packages.forEach(p => {
    //     packagesString +=  p.name + ' - '
    //   });

    //   return packagesString.trim().slice(0, -1)
    // },
    getPackages (reservation) {
      let packages = ''
      reservation.reservations_packages.forEach(rp => {
        const p = rp.package
        const unitMeasurement = this.unitMeasurements.find(p.unit_measurement_id).name
        const packageTotalPrice = Number(rp.repeated) * Number(p.unit_price) * Number(p.quantity)
        
        const reservationPackageTransactionIds = 
          reservation.reservation_transactions.filter(rt => rt.package_id === p.id)
            .map(rt => rt.transaction_id)
        
        const packageTransactions = this.transactions.map(t => reservationPackageTransactionIds.includes(t.id) && t).filter(Boolean)
        const totalPaid = window._.sumBy(packageTransactions, pt => Number(pt.amount))
        const remainderPrice = packageTotalPrice - totalPaid
        
        packages += ` <strong>${p.name}</strong>: <span style="color: ${Number(rp.remainder) > 0 ? 'green' : 'red'}"> ${Number(rp.remainder)}</span> ${unitMeasurement} - <span style="color:${remainderPrice > 0 ? 'red' : 'green'}">${this.formatPrice(remainderPrice)}</span> </br>`
      })

      return packages.trim().slice(0, -1)
    },
    setReservation(reservation) {
      this.$emit('room-reservation-search', {
        data: { reservation }
      })
    }
  },
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/rooms/room_components/visits_popup_components/ReservationSearch.vue